import {
  Alert,
  Box,
  Checkbox,
  Chip,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import React, { useContext } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { GenericTableProps, CenteredTableCell } from './utils';
import { isDesktop } from 'react-device-detect';
import DynamicCardListing from './mobile';
import QuickFilters from '../quick-filters/quick-filters';
import { IQuickFilter } from '../../../interfaces/common/quick-filters';
import { quickFiltersToFilterOptions } from '../../../utils/quick-filters';

function GenericTable<T extends object>(props: GenericTableProps<T>,) {
  const {
    items,
    selectionEnabled,
    selectedItems,
    updateSelectedItems,
    isLoading,
    columns,
    getItemUID,
    fullWidth,
    rowStyles,
    quickFiltersScope,
    applyQuickFilter,
    sourceView,
  } = { ...props };
  const toggleIdSelection = (item: T) => {
    if (updateSelectedItems)
      updateSelectedItems((draft) => {
        const rowId = getItemUID(item);
        if (draft.has(rowId)) draft.delete(rowId);
        else draft.set(rowId, item);
      });
  };

  const selectAllRows = (items: T[]) => {
    if (updateSelectedItems)
      updateSelectedItems((draft) => {
        items.forEach((item) => draft.set(getItemUID(item), item));
      });
  };

  const unSelectAllRows = (items: T[]) => {
    if (updateSelectedItems)
      updateSelectedItems((draft) => {
        items.forEach((item) => draft.delete(getItemUID(item)));
      });
  };

  const currentIds = items.map((item) => getItemUID(item));

  const numSelected = currentIds.reduce(
    (result: number, itemID: string) =>
      selectedItems.has(itemID) ? result + 1 : result,
    0
  );
  const rowCount = items.length;
  const allSelected = numSelected === rowCount;

  const { user, config } = useContext(AuthContext);

  if (user === null) return <div>Unauthenticated</div>;
  console.log('look here: ', items);

  return (
    <>
    {
      quickFiltersScope && <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%',  }} mb={2} mt={2} >
        <QuickFilters 
          scope={quickFiltersScope} 
          onSelect={(quickFilter: IQuickFilter | null)=>{
            applyQuickFilter && applyQuickFilter(quickFilter)
          }} 
          sourceView={sourceView}
        />
      </Box>
    }
    <TableContainer >
      {isLoading ? (
        <LinearProgress />
      ) : (
        items.length == 0 ? <Alert sx={{maxWidth: 500, margin: '0 auto'}} severity="info">No items to show!</Alert> :
        <Table size="small" stickyHeader style={{ width: fullWidth ? '100%' : 'auto' }}>
          <TableHead>
            <TableRow>
              {selectionEnabled && (
                <CenteredTableCell padding="checkbox">
                  <Checkbox
                    color="primary"
                    indeterminate={numSelected > 0 && numSelected < rowCount}
                    checked={
                      (allSelected ||
                        (rowCount > 0 && numSelected === rowCount)) &&
                      numSelected > 0
                    }
                    onChange={(e) => {
                      if (allSelected) unSelectAllRows(items);
                      else selectAllRows(items);
                    }}
                  />
                </CenteredTableCell>
              )}
              {columns
                .filter((item) => !item.hidden)
                .map((col) => (
                  <CenteredTableCell key={col.id}>
                    <b>{col.header}</b>
                  </CenteredTableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item, index) => {
              return (
                <TableRow
                  key={getItemUID(item)}
                  sx={rowStyles ? rowStyles(item) : {}}
                >
                  {selectionEnabled && (
                    <CenteredTableCell padding="checkbox">
                      <Checkbox
                        color="primary"
                        checked={selectedItems.has(getItemUID(item))}
                        onChange={(e) => {
                          toggleIdSelection(item);
                        }}
                      />
                    </CenteredTableCell>
                  )}

                  {columns
                    .filter((item) => !item.hidden)
                    .map((col) => (
                      <CenteredTableCell key={col.id}>
                        {col.display_body(item)}
                      </CenteredTableCell>
                    ))}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
    </TableContainer>
    </>
    
  );
}

export default GenericTable;
